namespace $.$$ {

	export class $shm_hitalama_map_widget_float_table_column extends $.$shm_hitalama_map_widget_float_table_column {

		title() { return `Настройки столбца «${ this.table().col_settings_title( this.column() ) }»` }

		panel_content() { return this.expanded() ? [ this.Head(), this.Code_scroll() ] : super.panel_content() }
		collapse_visible() { return this.expanded() ? super.collapse_visible() : [] }

		@ $mol_action
		expand( next?: Event ) {
			if( next ) this.expanded( true )
			return next ?? null
		}

		@ $mol_action
		collapse( next?: Event ) {
			if( next ) this.expanded( false )
			return next ?? null
		}

		name( next?: string ) { return this.table().col_name_draft( this.column(), next ) }
		name_commit( next?: Event ) { return this.table().col_name_commit( this.column(), next ) }
		width( next?: number ) { return this.table().col_width( this.column(), next ) }
		type( next?: string ) { return this.table().col_type( this.column(), next ) }
		type_options() { return this.table().col_type_options() }
		code( next?: string ) { return this.table().col_custom_code( this.column(), next ) }
		help() { return this.table().col_custom_code_help( this.column() ) }
		code_visible() { return this.type() === 'custom' ? super.code_visible() : [] }
	}
}
